export const ANIMATION_TIME = 300;
export const DEFAULT_TIME = '12:00';
